import { markConverters, getUnsupportedMarkFromTiptap } from './mark-converters.js';
import './marks/anchor-converter.js';
import 'ricos-schema';
import './marks/bold-converter.js';
import './marks/color-converter.js';
import 'ricos-types';
import './marks/font-size-converter.js';
import './marks/italic-converter.js';
import './marks/link-converter.js';
import './marks/mention-converter.js';
import './marks/spoiler-converter.js';
import './marks/underline-converter.js';

const MARKS_TO_DECORATIONS_BY_TYPE = Object.fromEntries(
  [...markConverters].reverse().flatMap((converter) => converter.fromTiptap.types.map((type) => [type, converter.fromTiptap]))
);
const marksToDecorations = (marks) => {
  if (!marks.length) {
    return [];
  }
  const conversions = /* @__PURE__ */ new Map();
  for (const mark of marks) {
    const converter = MARKS_TO_DECORATIONS_BY_TYPE[mark.type] || getUnsupportedMarkFromTiptap(mark);
    conversions.set(converter, [...conversions.get(converter) || [], mark]);
  }
  return Array.from(conversions.entries()).flatMap(
    ([converter, cMarks]) => converter.convert(cMarks)
  );
};

export { marksToDecorations };
//# sourceMappingURL=marks-to-decorations.js.map
